import { render, staticRenderFns } from "./MetricDescription.vue?vue&type=template&id=18e4ecd2&scoped=true"
import script from "./MetricDescription.vue?vue&type=script&lang=js"
export * from "./MetricDescription.vue?vue&type=script&lang=js"
import style0 from "./MetricDescription.vue?vue&type=style&index=0&id=18e4ecd2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e4ecd2",
  null
  
)

export default component.exports